export default __webpack_public_path__ + "static/media/FluidStorageIndustrial.256.8da7a167.png";